const ENV = import.meta.env;

const SIDE_MENU = {
  WIDTH_COLLAPSED: 90,
  WIDTH_EXPANDED: 240,
  HEADER_GAP: 33,
} as const;

export { ENV, SIDE_MENU };
